import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth.service';

export interface DashboardOverview {
  propertiesOwned: number;
  propertiesRented: number;
  pendingInstallments: number;
  overdueInstallments: number;
  openSupportTickets: number;
}

export interface DashboardNextPayment {
  amount?: number;
  currency?: string;
  dueDate?: string;
  contractId?: string;
}

export interface DashboardQuickActions {
  viewProperties: string;
  viewInstallments: string;
  viewContracts: string;
  trackConstruction: string;
  submitTicket: string;
}

export interface DashboardResponse {
  overview: DashboardOverview;
  nextPayment: DashboardNextPayment | null;
  quickActions: DashboardQuickActions;
}

@Injectable({ providedIn: 'root' })
export class SeekerDashboardService {
  private baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  getDashboard(): Observable<DashboardResponse> {
    const token = this.authService.getAccessToken();
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    return this.http.get<DashboardResponse>(`${this.baseUrl}/portal/dashboard`, { headers });
  }
}
